<!--
    校区管理-校区账单
    功能：展示校区账单列表数据
    说明：旧版
-->
<template>
  <div class="bill" v-loading="loading">
    <div class="search_box">
      <el-tabs class="month" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in month"
          v-if="item > 0"
          :key="index"
          :label="`${item}月份`"
          :name="item"></el-tab-pane>
      </el-tabs>
      <el-date-picker
        class="month_picker"
        v-model="dateValue"
        type="month"
        size="mini"
        :picker-options="expireTimeOption"
        value-format="yyyy-MM"
        placeholder="选择其他月份"
        :clearable="false"
        @change="changeDate">
      </el-date-picker>
    </div>
    <div class="info">
      <div class="title">
        <p>{{ day }}账单（{{ monthstart }} ~ {{ monthend }}）</p>
        <p>
          <span>每日上午7:00进行更新</span>
        </p>
      </div>
      <div class="count" v-if="type === 'factor'">
        <div>
          <p>{{ total.cash_payment | formatter }}</p>
          <p>消费金额（元）</p>
        </div>
        <div>
          <p>{{ total.gold_payment | formatter }}</p>
          <p>金币消费（个）</p>
        </div>
      </div>
      <div class="title">服务明细</div>
      <el-table
        ref="table"
        :data="cashList"
        :border="true">
        <el-table-column
          prop="name"
          label="服务"
        />
        <el-table-column
          label="分钟数"
          prop="number"
        />
        <el-table-column
          v-if="type === 'factor'"
          label="消费金额"
          :formatter="row => `${Number(row.cash_payment).toFixed(2)}元`"
        />
        <el-table-column
          width="120px"
          label="操作">
          <template slot-scope="scope" v-if="$permissions('school_billing_bill_info')">
            <template v-if="scope.row.code === 'school_record' || scope.row.code === 'school_replay' || scope.row.code === 'school_teaching'">
              <el-link
                v-if="$store.state.from === 'schoolCenter'"
                @click="cashDetail(scope.row)"
              >详单</el-link>
              <el-button
                v-else
                size="small"
                @click="cashDetail(scope.row)"
              >详单</el-button>
            </template>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">金币明细</div>
      <el-table
        ref="table"
        :data="goldList"
        :border="true">
        <el-table-column
          prop="name"
          label="服务"
        />
        <el-table-column
          prop="number"
          label="数量"
        />
        <el-table-column
          label="消费金币"
          :formatter="row => `${Number(row.gold_payment).toFixed(2)}`"
        />
        <el-table-column
          width="120px"
          label="操作">
          <template slot-scope="scope" v-if="$permissions('school_billing_bill_info')">
            <el-link
              v-if="$store.state.from === 'schoolCenter'"
              @click="goldDetail(scope.row)"
            >详单</el-link>
            <el-button
              v-else
              size="small"
              @click="goldDetail(scope.row)"
            >详单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import baseUrl from "../../utils/api";

  export default {
    name: "Bill",
    data() {
      return {
        loading: false,
        id: this.$route.params.id || undefined,
        type: this.$route.query.type || undefined,
        activeName: '',
        day: '',
        monthstart: '',
        monthend: '',
        month: [],
        dateValue: '',
        expireTimeOption: {
          disabledDate(time) {
            return time.getTime() < 1585670400000;   //禁用2020-04以前的日期
          }
        },
        cashList: [],
        goldList: [],
        total: {
          cash: 0,
          gold: 0
        },
        columns: [
          { prop: 'name', label: '校区' },
          { prop: 'name1', label: '消费金额' },
          { prop: 'name2', label: '金币消费' }
        ]
      }
    },
    filters: {
      formatter(val) {
        return Number(val).toFixed(2);
      }
    },
    computed: {
      school() {
        return this.$store.state.choicesSchool
      }
    },
    created() {
      const today = this.$moment(new Date()); // 当前日期
      const month = today.month() + 1; // 当前月份
      this.setTime(month, today);
      this.activeName = String(month); // 激活当前月份
      const date = [];
      for (let i = month; date.length < 3; i--) {
        date.push(String(i));
      }
      this.month = date;  // 月份数组
    },
    methods: {
      // 月份切换
      handleClick(tab) {
        this.setTime(tab.name, this.$moment(new Date()))
      },
      // 其他月份选择
      changeDate(val) {
        this.activeName = '';
        this.setTime(this.$moment(val).month() + 1, val);
      },
      // 设置时间
      setTime(time, date) {
        const today = this.$moment(date).set('month', (time - 1) );
        this.day = today.format('YYYY年MM月'); // 转换格式
        this.created_at = today.format('YYYY-MM');
        this.monthstart = today.startOf('month').format('YYYY-MM-DD'); // 当月第一天
        this.monthend = today.endOf('month').format('YYYY-MM-DD'); // 当月最后一天
        this.load(this.school.main_id, this.created_at);
      },
      bill(row) { // 校区账单
        this.$router.push(`/account/bill/${row.id}`)
      },
      // 加载信息
      load(id, time) {
        this.loading = true;
        const school_id = this.id ? this.id : this.school.id;
        const api = this.type && this.type === 'factor' ?
                    `${baseUrl}/api/service/agent/bill/detail/${time}/client/${school_id}?clients_id=${school_id}` :
                    `${baseUrl}/api/expense/main/${id}/detail/${time}/client/${school_id}?clients_id=${school_id}`
        this.$http.get(api)
          .then((res) => {
            this.loading = false;
            this.total = res.data.total;
            const arr = [];
            for (let i in res.data.service) {
              for (let b in res.data.service[i].detail) {
                arr.push(res.data.service[i].detail[b]);
              }
            }
            arr.forEach(val => {
              val.code === 'course_commodities' && (val.number = val.order_number);
            });
            // 金币服务类型 线上课程、线上课件、线下课程、线下课件、课件打包 course_ware_pack
            const arrGold = ['online_course', 'online_course_ware', 'offline_course', 'offline_course_ware', 'course_commodities'];
            // 现金服务类型 直播教学、录制费用、回放费用
            const arrCash = ['school_teaching', 'school_record', 'school_replay'];
            this.cashList = arr.filter(item => arrCash.includes(item.code)); // 现金服务
            this.goldList = arr.filter(item => arrGold.includes(item.code)); // 课件服务
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      },
      // 现金详单
      cashDetail(row) {
        if (this.id) {
          this.$router.push(`/statistical/list?factor=${this.type}&id=${this.id}&code=${row.code}&page=1&per_page=10`)
        } else {
          this.$router.push(`/statistical/list?factor=${this.type}&code=${row.code}&page=1&per_page=10`);
        }
      },
      // 金币详单
      goldDetail(row) {
        if (row.code === 'course_commodities') {
          this.$router.push(`/statistical/list?active=school_course&created_at=${this.created_at}`);
        } else if (this.id) {
          this.$router.push(`/statistical/list?factor=${this.type}&id=${this.id}&type=${row.code}&code=school_teaching&page=1&per_page=10`);
        } else {
          this.$router.push(`/statistical/list?factor=${this.type}&type=${row.code}&code=school_teaching&page=1&per_page=10`);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bill {
    .search_box {
      margin-top: 10px;
      .month {
        display: inline-block;
        vertical-align: top;
        /deep/ .el-tabs__nav-wrap {
          &:after {
            display: none;
          }
        }
      }
      .month_picker {
        vertical-align: top;
        display: inline-block;
        width: 150px;
        margin-top: 7px;
        margin-left: 15px;
      }
    }
    .info {
      .title {
        margin: 20px 0;
        font-size: 16px;
        color: #666;
        p {
          font-size: 14px;
          color: #909399;
          span {
            font-size: 12px;
          }
        }
      }
      .count {
        display: flex;
        div {
          flex: 1;
          margin-right: 20px;
          box-sizing: border-box;
          border: 1px solid #ccc;
          padding: 20px;
          text-align: center;
          &:last-child {
            margin: 0;
          }
          p {
            color: #909399;
            &:first-child {
              color: #333;
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Bill/index.vue